import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from '../../shared/reactSelect/select.component';
import TruncatableSelect from '../../shared/reactSelect/truncatableSelect.component';
import HamburgerDropdown from './hamburgerDropdown.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import AccountBalancesGrid from './viewAccountBalancesGrid.component';

import { selectPeriod } from '../../shared/store/actions';
import { environmentSuffixSelector } from '../../shared/store/selectors';
import {
  fetchSlGroupsInitialData,
  changeSlGroupTypeAndFetch,
} from '../aggregationMenu/store/actions';
import {
  selectSlGroupTypes,
  selectSlGroupType,
} from '../aggregationMenu/store/selectors';
import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector } from '../../userData/store/selectors';

import {
  fetchAccountBalances,
  fetchSlAccounts,
  selectSlAccounts,
} from './store/actions';
import {
  accountBalancesSelector,
  accountBalancesLoadingSelector,
  slAccountsForSelectSelector,
  slAccountsLoadingSelector,
  selectedSlAccountsSelector,
} from './store/selectors';

import {
  groupTypePropTypes,
  groupTypesForSelectPropTypes,
  slAccountsForSelectPropTypes,
  accountBalancesPropTypes,
} from './viewAccountBalances.proptypes';
import downloadAccountBalancesXlsx from './downloadAccountBalancesXlsx';

class ViewAccountBalancesPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    accountBalancesLoading: PropTypes.bool.isRequired,
    slGroupType: groupTypePropTypes,
    slGroupTypesForSelect: groupTypesForSelectPropTypes,
    slAccountsForSelect: slAccountsForSelectPropTypes,
    selectedSlAccounts: slAccountsForSelectPropTypes,
    accountBalances: accountBalancesPropTypes,

    fetchAccountBalances: PropTypes.func.isRequired,
    fetchSlGroupsInitialData: PropTypes.func.isRequired,
    fetchSlAccounts: PropTypes.func.isRequired,
    selectSlAccounts: PropTypes.func.isRequired,
    selectPeriod: PropTypes.func.isRequired,
    selectSlGroupType: PropTypes.func.isRequired,

    shouldDisplayZero: PropTypes.bool.isRequired,
    hideDecimals: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
    environmentSuffix: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const {
      period,
      slGroupType,
      fetchSlGroupsInitialData,
      fetchSlAccounts,
      fetchAccountBalances,
    } = this.props;

    fetchSlAccounts(period.name);
    fetchSlGroupsInitialData({
      slGroupType,
    });

    if (slGroupType?.value && period) {
      fetchAccountBalances({
        periodName: period.name,
        displayBy: slGroupType.value,
      });
    }
  }

  componentDidUpdate = prevProps => {
    const { period, slGroupType, fetchAccountBalances } = this.props;
    const { period: prevPeriod, slGroupType: prevSlGroupType } = prevProps;

    const thereWasNoPreviousSlGroupType = !prevSlGroupType && slGroupType;
    const currentAndPreviousPeriodsAreDifferent = period && prevPeriod && period.name !== prevPeriod.name;
    const currentAndPreviousSlGroupTypesAreDifferent
      = slGroupType && prevSlGroupType && slGroupType.value !== prevSlGroupType.value;

    if (thereWasNoPreviousSlGroupType
      || currentAndPreviousPeriodsAreDifferent
      || currentAndPreviousSlGroupTypesAreDifferent
    ) {
      fetchAccountBalances({
        periodName: period.name,
        displayBy: slGroupType.value,
      });
    }
  };

  selectPeriod = selectedPeriod => {
    const { periods, selectPeriod, fetchSlAccounts } = this.props;

    const value = selectedPeriod ? selectedPeriod.value : null;
    const period = periods.find(period => period.name === value);

    selectPeriod(period);
    fetchSlAccounts(period.name);
  };

  selectSlGroupType = selectedSlGroupType => {
    const { selectSlGroupType, period } = this.props;
    selectSlGroupType({ groupType: selectedSlGroupType, periodName: period.name });
  };

  selectAccounts = selectedAccounts => {
    const { selectSlAccounts } = this.props;
    selectSlAccounts(selectedAccounts);
  };

  downloadAccountBalances = callback => {
    const {
      accountBalances,
      period,
      slGroupType,
      selectedSlAccounts,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    } = this.props;

    downloadAccountBalancesXlsx({
      groupType: slGroupType,
      accountBalances,
      periodName: period.name,
      selectedSlAccounts,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    });
    callback();
  };

  render() {
    const {
      slGroupType,
      slGroupTypesForSelect,
      slAccountsForSelect,
      selectedSlAccounts,
      accountBalances,
      accountBalancesLoading,
    } = this.props;

    return (
      <div className="view-account-balances">
        <SecondaryMenu>
          <div className="aggregation-menu">
            <div className="aggregation-group">
              <div className="aggregation-selector">
                <PeriodDropdown
                  onChange={this.selectPeriod}
                />
              </div>
              <div className="aggregation-selector">
                <div className="aggregation-label aggregation-label-md">Display by</div>
                <Select
                  clearable={false}
                  name="groupType"
                  options={slGroupTypesForSelect}
                  onChange={this.selectSlGroupType}
                  scrollMenuIntoView={false}
                  value={slGroupType}
                  className="select-entry-types"
                />
              </div>
              <div className="aggregation-selector">
                <div className="aggregation-label aggregation-label-md">Display accounts</div>
                <TruncatableSelect
                  clearable
                  multi
                  removeSelected
                  virtualized
                  withAll
                  closeOnSelect={false}
                  onChange={this.selectAccounts}
                  name="slAccount"
                  options={slAccountsForSelect}
                  scrollMenuIntoView={false}
                  value={selectedSlAccounts}
                  className="select-sl-accounts"
                  placeholder="Select accounts..."
                />
              </div>
            </div>
          </div>
          <div className="hamburger-dropdown ml-auto text-right">
            <HamburgerDropdown
              cannotDownloadAccountBalances={Boolean(accountBalancesLoading && slGroupType && slGroupType.value)}
              downloadAccountBalances={this.downloadAccountBalances}
            />
          </div>
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <AccountBalancesGrid
                  groupType={slGroupType}
                  accountBalances={accountBalances}
                  accountBalancesLoading={accountBalancesLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  balances: state.balanceSheetManagement.shared.accountBalances,
  period: state.shared.period,
  periods: state.shared.periods,
  slAccountsForSelect: slAccountsForSelectSelector(state),
  slAccountsLoading: slAccountsLoadingSelector(state),
  slGroupType: selectSlGroupType(state),
  slGroupTypesForSelect: selectSlGroupTypes(state),
  selectedSlAccounts: selectedSlAccountsSelector(state),
  accountBalances: accountBalancesSelector(state),
  accountBalancesLoading: accountBalancesLoadingSelector(state),
  shouldDisplayZero: displayZeroSelector(state),
  hideDecimals: hideDecimalsSelector(state),
  negativeMinus: negativeMinusSelector(state),
  environmentSuffix: environmentSuffixSelector(state),
});

export default connect(mapStateToProps, {
  fetchAccountBalances,
  fetchSlGroupsInitialData,
  fetchSlAccounts,
  selectSlAccounts,
  selectPeriod,
  selectSlGroupType: changeSlGroupTypeAndFetch,
})(ViewAccountBalancesPage);
